import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <main id="main-content" className="bg-[#0a0a0a] pt-24">
    <section className="relative overflow-hidden bg-[#ff6b35] noise min-h-[70vh] flex items-center">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-16 md:py-24 relative">
        <div className="inline-block bg-[#0a0a0a] text-white px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-5">
          404
        </div>
        <h1 className="font-display text-[#0a0a0a] text-[3rem] min-[380px]:text-6xl sm:text-8xl uppercase leading-[0.85] max-w-5xl">
          Página não encontrada.
        </h1>
        <p className="mt-6 max-w-2xl text-[#0a0a0a]/75 text-lg sm:text-xl leading-snug">
          Esta rota não existe ou foi movida. Pode voltar às soluções, ler insights ou pedir um diagnóstico digital gratuito.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <Link to="/solucoes" className="btn-brutal">
            <span>Ver soluções</span>
            <ArrowRight size={18} className="shrink-0" />
          </Link>
          <Link to="/diagnostico-digital" className="btn-brutal btn-brutal-orange">
            <span>Pedir diagnóstico</span>
            <ArrowRight size={18} className="shrink-0" />
          </Link>
        </div>
      </div>
    </section>
  </main>
);

export default NotFoundPage;
